import { Lock } from "lucide-react";

/**
 * Iter462 — Shared "FESTIVAL ENDED" banner. Mirrors the Iter461
 * design on Player Manager byte-for-byte so every organiser-facing
 * surface renders an identical lock treatment once the festival is
 * read-only. The "Request Festival Extension" button is a stub —
 * backend wiring is intentionally deferred per spec.
 */
export default function FestivalEndedBanner() {
  return (
    <div
      data-testid="festival-ended-banner"
      className="border border-[#FFB020] bg-[#1A140A] p-3 mb-4 flex items-start gap-3 flex-wrap"
    >
      <Lock className="w-5 h-5 text-[#FFB020] shrink-0 mt-0.5" />
      <div className="min-w-0 text-sm text-white flex-1">
        <div className="label-mono text-[#FFB020] text-[10px]">FESTIVAL ENDED</div>
        This festival has ended. Player data is now read-only.
      </div>
      <button
        type="button"
        data-testid="festival-ended-request-extension"
        onClick={() => { /* stub — backend wiring deferred */ }}
        className="inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-wider border border-[#FFB020] text-[#FFB020] hover:bg-[#FFB020] hover:text-black"
      >
        Request Festival Extension
      </button>
    </div>
  );
}
